export default __webpack_public_path__ + "static/media/img7.7a45919b.png";